import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild } from "@angular/core";
import { OrderService } from "../order.service";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { filter, take, takeUntil } from "rxjs/operators";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { SaleMethodBranchModel, SaleMethodNature } from "../../sales/model/sale-method-branch.model";
import { DiscountTypeEnum, Invoice, InvoiceCommand, InvoiceEntry, InvoiceItem, InvoiceStatus, PaymentLinkState } from "../model/invoice.model";
import { ActivePageEnum } from "../model/activepage.enum";
import { MapObjectPipe } from "projects/sepidz-web-framework/src/lib/pipes/mapobject.pipe";
import { Branch, EntityListAction, form_control, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { AccountService, GridFilter, PagingDataResult } from "projects/sepidz-web-framework/src/lib/services";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { LocalSettingService } from "../../local-setting/local-setting.service";
import { InvoiceActionService } from "../providers/invoiceaction.service";
import { RowState } from "../../../../../projects/sepidz-web-framework/src/lib/models/enums";
import { DataCenterProcess } from "src/app/gnr/data-center-process/data-center-process.model";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { InvoiceExportExcelModel } from "../model/ItemCategoryOrder.model";
import { ConfirmDateValue, DateDialogComponent } from "../../dateDialog/dateDialog.component";
import { Subject } from "rxjs";
import { TotalPriceService } from "../orderpage/invoice/totalprice/totalprice.service";
import { GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { ColumnBase } from "@progress/kendo-angular-grid";
import { DepositModel } from "../../catalog/model/deposit.model";
import { EnumModel } from "../orderpage/item/deposit/deposit.component";
import { MealEnum } from "../../catalog/model/deposit.enum";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import * as moment from "moment";
import { Customer } from "../../parties/model/customer.model";

type NewType = GridFilter;

@Component({
  selector: "order-invoices",
  templateUrl: "./invoices.component.html",
  styleUrls: ["./invoices.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoicesComponent extends BaseListComponent {
  @ViewChild("invoiceGrid") invoiceGrid: KGridComponent;
  @ViewChild("itemGrid") itemGrid: KGridComponent;
  @Input() currentSaleMethodBranch: SaleMethodBranchModel;
  @Input() currentFilter: any;
  actions: EntityListAction[] = [];
  filterInfo: GridFilter[] = [];
  unSortableFilterable: string[] = [];
  InvoiceItemColumns: form_control[] = [];
  InvoiceItems: InvoiceItem[];
  onFilter: GridFilter[] = [];
  invoicestatus: typeof InvoiceStatus = InvoiceStatus;
  selectedFilter: any;
  invoices: PagingDataResult<Invoice> = new PagingDataResult<Invoice>();
  isFinishedData: boolean = false;
  erroremessage: string;
  invoice: Invoice;
  IgnoreDeletePermission: boolean = false;
  MealTimeDataList: EnumModel[];
  InvoiceIdList: number[] = [];
  invoiceFilter: any[] = [
    {
      key: 1,
      title: this.translate("ClientApp.FrontOffice.Order.Invoices.Temporary"),
      count: 0,
      selected: false,
      value: InvoiceStatus.Pending,
    },
    {
      key: 2,
      title: this.translate("ClientApp.FrontOffice.Order.Invoices.Order"),
      count: 0,
      selected: false,
      value: InvoiceStatus.Ordering,
    },
    {
      key: 3,
      title: this.translate("ClientApp.FrontOffice.Order.Invoices.Unsettled"),
      count: 0,
      selected: false,
      value: InvoiceStatus.Clearing,
    },
    {
      key: 4,
      title: this.translate("ClientApp.FrontOffice.Order.Invoices.Settled"),
      count: 0,
      selected: false,
      value: InvoiceStatus.Cleared,
    },
  ];

  formGroup = new UntypedFormGroup({
    branchFilter: new UntypedFormControl(),
    invoiceFilter: new UntypedFormControl(),
    MealTime: new UntypedFormControl(),
  });

  allBranchesExceptCallCenter = this.order.Branches.filter((x) => !x.AccessToAllBranches);
  depositFilterIsSelected = false;

  constructor(
    public order: OrderService,
    protected cd: ChangeDetectorRef,
    __id: FormContainerModel,
    private localSettingService: LocalSettingService,
    private tabsservice: TabularService,
    public invoiceAction: InvoiceActionService,
    public accountService: AccountService,
    public totalPriceService: TotalPriceService,
    private splashFormService: SplashFormService
  ) {
    super();
    this.NoLog = true;
    this.currentTabId = __id.metadata.id;
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    this.areaName = "RestaurantSale";
    this.apiName = "Invoice/ReadGetAllInvoices";
    if (!this.order.HasAccess("InvoicesList")) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Invoices.AccessToThisPage")}`,
        this.translate("ClientApp.FrontOffice.Order.Invoices.ErrorMessage")
      );
      return;
    }
    this.GetColumns();
    if (this.order.currentSaleMethodNature === SaleMethodNature.Delivery)
      this.invoiceFilter.push({
        key: 5,
        title: this.translate("ClientApp.FrontOffice.Order.Invoices.NotAssigned"),
        count: 0,
        selected: false,
        value: InvoiceStatus.Ordering,
      });
    this.localSettingService.tabsservice = this.tabsservice;
    this.unSortableFilterable = [];
    this.unSortableFilterable.push("TotalService_ShippingCost");
    this.unSortableFilterable.push("VoucherNumber");
    this.unSortableFilterable.push("SettlementInvoiceCreatedDateTime");
    if (!this.order.common.isMobileMode) this.setactions();
    if (!this.order.HasAccess("InvoicesListPreviousDays")) {
      this.httpCommonService
        .get("UserLocalSetting/CurrentDate")
        .pipe(take(1))
        .subscribe((data: Invoice) => {
          this.filterInfo.push({
            Filed: "CreatedDate",
            Value: data,
            Skip: 0,
            Take: 0,
            Operator: "gte",
            Type: "F",
            Logic: "and",
          });
          this.filterInfo.push({
            Filed: "CreatedDate",
            Value: data,
            Skip: 0,
            Take: 0,
            Operator: "asc",
            Type: "S",
          });
          this.fillData();
        });
    } else {
      this.fillData();
    }
    if (this.order.saleMethodBranch.HasDeposit && this.order.depositListGridFilter) {
      this.onFilter = Object.assign([], this.filterInfo);
      this.onFilter.push(...this.order.depositListGridFilter);
      this.depositFilterIsSelected = true;
    }
  }

  getParamsForExportExcelWithPostMethod(): Promise<any> {
    return new Promise((resolve, reject) => {
      const confirmValue: Subject<ConfirmDateValue> = new Subject();
      confirmValue
        .pipe(
          take(1),
          filter((x) => !!x)
        )
        .subscribe((value) => {
          const sendData: InvoiceExportExcelModel = {
            BranchIds: this.order.isMultiBranch ? this.formGroup.get("branchFilter").value : [this.order.logInBranch.Id],
            SaleMethodId: this.order.saleMethodBranch.SaleMethod.Id,
            StartDate: value.StartDate,
            EndDate: value.EndDate,
            InvoiceGridInfo: this.getGridInfo(this.invoiceGrid.grid.columns.toArray()),
            ItemGridInfo: this.getGridInfo(this.itemGrid.grid.columns.toArray()),
          };
          resolve(sendData);
        });
      this.dialogService.open(DateDialogComponent, { confirmValue }, {});
    });
  }

  getGridInfo(columns: ColumnBase[]): GridColumnInfoDetail[] {
    return columns
      .filter((x) => !x.hidden)
      .map((x) => {
        const info = new GridColumnInfoDetail();
        info.name = x["field"];
        info.hidden = x.hidden;
        info.orderindex = x.orderIndex;
        info.title = x.title;
        return info;
      });
  }

  fillData() {
    if (!this.order.isMultiBranch) {
      this.filterInfo.push({
        Filed: "SaleMethodId",
        Value: this.currentSaleMethodBranch.SaleMethodId,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      });
      this.filterInfo.push({
        Filed: "SaleMethodBranchId",
        Value: this.currentSaleMethodBranch.Id,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      });
    }

    if (this.accountService.authService.currentFiscalYear)
      this.filterInfo.push({
        Filed: "FiscalYearId",
        Value: this.accountService.authService.currentFiscalYear.Id,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      });
    else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x)
          this.filterInfo.push({
            Filed: "FiscalYearId",
            Value: this.accountService.authService.currentFiscalYear.Id,
            Skip: 0,
            Take: 0,
            Operator: "eq",
            Type: "F",
          });
      });
    if (!this.order.HasAccess("InvoicesListForOtherUsers")) {
      this.filterInfo.push({
        Filed: "CreatedUserId",
        Value: this.accountService.authService.currentUser.Id,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      });
    }
    if (!this.order.HasAccess("InvoicesListForCleared")) {
      this.filterInfo.push({
        Filed: "StatusCode",
        Value: InvoiceStatus.Cleared,
        Skip: 0,
        Take: 0,
        Operator: "lt",
        Type: "F",
      });
    }
    this.filterInfo.push({
      Filed: "StatusCode",
      Value: InvoiceStatus.Deleted,
      Skip: 0,
      Take: 0,
      Operator: "neq",
      Type: "F",
    });
    if (!this.order.isMultiBranch) {
      this.filterInfo.push({
        Filed: "BranchId",
        Value: this.order.logInBranch.Id,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      });
    }
    this.onFilter = Object.assign([], this.filterInfo);
    if (this.currentFilter) {
      this.setFilter(this.currentFilter);
    }
    const a = new DataCenterProcess();
    a.BranchId = this.order.logInBranch.Id;
    a.MainTableName = "Invoices";
    this.setDefaultBranch();
    const hasBranchCommunication = JSON.parse(localStorage.getItem("HasBranchCommunication"));
    if (hasBranchCommunication == null) {
      this.httpCommonService
        .getList(`Branch/HasBranchCommunication/${this.order.logInBranch.Id}`)
        .pipe(take(1))
        .subscribe((hbc: boolean) => {
          localStorage.setItem("HasBranchCommunication", JSON.stringify(hbc));
          if (hbc) {
            this.getDataTransferInfo(a);
          }
        });
    } else if (hasBranchCommunication) {
      this.getDataTransferInfo(a);
    }
    this.MealTimeDataList = this.enumToEnumModelArray(MealEnum);
  }
  getDataTransferInfo(a: DataCenterProcess) {
    this.httpCommonService
      .create(`DataCenterProcess/GetDataTransferInfo`, a)
      .pipe(take(1))
      .subscribe((hbc: boolean) => {
        if (hbc === true) {
          if (a.TransferKindCode !== 1 && a.TransferKindCode !== 4 && a.TransferKindCode !== 3) {
            this.erroremessage = this.translate("ClientApp.FrontOffice.Order.Invoices.HasBranchCommunication");
          }
        } else {
          if (a.TransferKindCode !== 2 && a.TransferKindCode !== 5 && a.TransferKindCode !== 3) {
            this.erroremessage = this.translate("ClientApp.FrontOffice.Order.Invoices.HasCallCenterCommunication");
          }
        }
      });
  }

  enumToEnumModelArray(enumObj: any): EnumModel[] {
    return Object.keys(enumObj)
      .filter((key) => !isNaN(Number(enumObj[key])))
      .map((key) => ({ Id: enumObj[key], Title: key }));
  }
  async GetColumns() {
    await this.httpCommonService
      .getControlsList("Invoice")
      .pipe(take(1))
      .toPromise()
      .then(
        (data) => {
          if (data) {
            this.columns = data as form_control[];
            this.columns = this.columns.sort((a, b) => a.order - b.order);
            const status = this.columns.find((x) => x.name === "StatusTitle");
            if (status) {
              status.controlType = FormControlTypes.colorPicker;
              status.getBgColor = (invoice: Invoice) => {
                if ((invoice.StatusTitle as any) == this.translate("ClientApp.FrontOffice.Order.Invoices.Cancel")) {
                  return "cell-custom-status danger";
                }
              };
            }
            const linkCol = this.columns.find((x) => x.name === "PaymentLinkState");
            if (linkCol) {
              linkCol.controlType = FormControlTypes.colorPicker;
              linkCol.getBgColor = (invoice: Invoice) => {
                if ((invoice.PaymentLinkState as any) == this.translate("ClientApp.FrontOffice.Order.Invoices.Paid")) {
                  return "cell-custom-state positive";
                }
                if ((invoice.PaymentLinkState as any) == this.translate("ClientApp.FrontOffice.Order.Invoices.ProblemPaying")) {
                  return "cell-custom-state danger";
                } else return "";
              };
            }
            this.InvoiceItemColumns = this.getDetailControlModels("Items") as form_control[];
            this.InvoiceItemColumns = this.InvoiceItemColumns.sort((a, b) => a.order - b.order);
          }
        },
        (error) => console.log(error)
      );
  }
  getDetailControlModels(keyName: string) {
    if (this.columns?.find((x) => x.name === keyName)?.DetailControlModels)
      return this.columns.find((x) => x.name === keyName).DetailControlModels[keyName];
    return [];
  }
  deleteFormHelper(row: any) {
    let test = 0;
  }

  public onBranchFilterChanged(branches: Branch[]): void {
    if (branches.length) this.filterBranchWithOrOperator(branches);
    else this.onBranchFilterClear();
  }

  public onBranchFilterClear(): void {
    this.onFilter = [
      {
        Filed: "BranchId",
        Value: 0,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      },
    ];
  }

  onActionClick(action: EntityListAction, onRowSelected: Invoice, onRowsSelected: Invoice[], isAllSelected: boolean, gridFilter: NewType[]) {
    if (!onRowSelected) return;
    if (
      onRowSelected.StatusCode == InvoiceStatus.Pending &&
      !(
        action.name === "CustomerPrint" ||
        action.name === "PreparationPrint" ||
        action.name === "ChangeCustomerPrintTemplate" ||
        action.name === "PrintReceipt"
      )
    ) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Order.Invoices.AccessToThisArea"),
        this.translate("ClientApp.FrontOffice.Order.Invoices.Attention")
      );
      return;
    } else if (
      onRowSelected.StatusCode == InvoiceStatus.Pending &&
      (action.name === "CustomerPrint" ||
        (!this.accountService.authService?.currentInformation()?.OrderServices && !this.order.saleMethodBranch?.HasDeposit) ||
        action.name === "PreparationPrint" ||
        action.name === "ChangeCustomerPrintTemplate")
    ) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Order.Invoices.UnableToReprintInTemporaryState"),
        this.translate("ClientApp.FrontOffice.Order.Invoices.Attention")
      );
      return;
    }

    if (onRowSelected && (!onRowsSelected || onRowsSelected.length <= 0)) onRowsSelected = [onRowSelected];

    this.order.splashFormService.openDialog("", " ");
    this.httpCommonService
      .get(`Invoice/GetInvoiceById/${onRowsSelected[0].Id}`)
      .pipe(take(1))
      .subscribe(
        (data: Invoice) => {
          if (action.name === "SendInvoiceSms") {
            this.sendInvoiceSms(data);
            this.order.splashFormService.closeLoading();
            return;
          } else if (action.name === "PrintReceipt" || this.order.saleMethodBranch?.HasDeposit) {
            this.httpCommonService
              .getItem("Deposit/GetByInvoiceId", data.Id)
              .pipe(take(1))
              .subscribe((invoiceDeposit: DepositModel) => {
                this.order.splashFormService.closeLoading();
                if (data) {
                  data.Deposit = invoiceDeposit;
                  data.MultiPhoneNumber = onRowSelected.MultiPhoneNumber;
                  this.afterActionClick(action, data);
                }
              }),
              () => {
                this.order.splashFormService.closeLoading();
              };
          } else {
            this.afterActionClick(action, data);
            this.order.splashFormService.closeLoading();
          }
        },
        (error) => {
          this.order.splashFormService.closeLoading();
        }
      );
  }

  private afterActionClick(action: EntityListAction, data: Invoice) {
    if (
      action.name === "CustomerPrint" ||
      action.name === "PreparationPrint" ||
      action.name === "CustomerFinancialPrint" ||
      action.name === "ChangeCustomerPrintTemplate" ||
      action.name === "PrintReceipt"
    ) {
      const invoice = this.checkInvoiceState(JSON.parse(JSON.stringify(data)), action.name);
      if (action.name === "PreparationPrint") {
        if (this.order.HasAccess("KitchenRePrint")) this.invoiceAction.SaveInvoice(invoice.CommandCode, invoice, true, this.order);
        else
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Order.Invoices.AccessToThisArea"),
            this.translate("ClientApp.FrontOffice.Order.Invoices.Attention")
          );
      }
      if (action.name === "ChangeCustomerPrintTemplate") this.totalPriceService.changePrintTemplate(invoice);

      if (action.name === "CustomerPrint") {
        if (this.order.HasAccess("CustomerRePrint")) this.invoiceAction.SaveInvoice(invoice.CommandCode, invoice, true, this.order);
        else
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Order.Invoices.AccessToThisArea"),
            this.translate("ClientApp.FrontOffice.Order.Invoices.Attention")
          );
      }

      if (action.name === "CustomerFinancialPrint") this.invoiceAction.SaveInvoice(invoice.CommandCode, invoice, true, this.order);
      if (action.name === "PrintReceipt") {
        invoice.IsReceiptPrint = true;
        this.invoiceAction.SaveInvoice(invoice.CommandCode, invoice, true, this.order);
      }
    }
    this.invoiceAction.saveEnd.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {
      this.order.splashFormService.closeLoading();
      this.tabsservice.tabItemonRefreshData.next(this.apiName);
    });
  }

  /// چک کردن استیت فاکتور
  checkInvoiceState(invoice: Invoice, commond: string): Invoice {
    switch (this.order.currentSaleMethodNature) {
      case this.order.SaleMethodNature.Restaurant:
        switch (commond) {
          case "CustomerPrint":
            if (
              invoice.StatusCode === InvoiceStatus.New ||
              invoice.StatusCode === InvoiceStatus.Pending ||
              invoice.StatusCode === InvoiceStatus.Ordering
            ) {
              invoice.StatusCode = InvoiceStatus.Clearing;
              invoice.CommandCode = InvoiceCommand.CustomerPrint;
            } else {
              invoice.CommandCode = InvoiceCommand.ReprintForCustomer;
            }
            break;
          case "ChangeCustomerPrintTemplate":
            if (
              invoice.StatusCode === InvoiceStatus.New ||
              invoice.StatusCode === InvoiceStatus.Pending ||
              invoice.StatusCode === InvoiceStatus.Ordering
            ) {
              invoice.StatusCode = InvoiceStatus.Clearing;
              invoice.CommandCode = InvoiceCommand.CustomerPrint;
            } else {
              invoice.CommandCode = InvoiceCommand.ReprintForCustomer;
            }
            break;
          case "PreparationPrint":
            if (invoice.StatusCode === InvoiceStatus.New || invoice.StatusCode === InvoiceStatus.Pending) {
              invoice.StatusCode = InvoiceStatus.Ordering;
              invoice.CommandCode = InvoiceCommand.PreparationPrint;
            } else invoice.CommandCode = InvoiceCommand.ReprintForPreparation;
            break;
          default:
        }

        break;
      case this.order.SaleMethodNature.Delivery:
        switch (commond) {
          case "PrintReceipt":
            invoice.CommandCode = InvoiceCommand.ReceiptPrint;
            break;
          case "CustomerPrint":
            if (invoice.StatusCode === InvoiceStatus.New || invoice.StatusCode === InvoiceStatus.Pending) {
              invoice.CommandCode = InvoiceCommand.CustomerPrint;
              invoice.StatusCode = InvoiceStatus.Ordering;
            } else {
              invoice.CommandCode = InvoiceCommand.ReprintForCustomer;
            }
            break;
          case "ChangeCustomerPrintTemplate":
            if (invoice.StatusCode === InvoiceStatus.New || invoice.StatusCode === InvoiceStatus.Pending) {
              invoice.CommandCode = InvoiceCommand.CustomerPrint;
              invoice.StatusCode = InvoiceStatus.Ordering;
            } else {
              invoice.CommandCode = InvoiceCommand.ReprintForCustomer;
            }
            break;
          case "PreparationPrint":
            if (invoice.StatusCode === InvoiceStatus.New || invoice.StatusCode === InvoiceStatus.Pending) {
              invoice.CommandCode = InvoiceCommand.PreparationPrint;
              invoice.StatusCode = InvoiceStatus.Ordering;
            } else {
              invoice.CommandCode = InvoiceCommand.ReprintForPreparation;
            }
          default:
        }
        break;
      case this.order.SaleMethodNature.FastFood:
        switch (commond) {
          case "CustomerPrint":
            if (
              invoice.StatusCode === InvoiceStatus.New ||
              invoice.StatusCode === InvoiceStatus.Pending ||
              invoice.StatusCode === InvoiceStatus.Ordering
            ) {
              invoice.StatusCode = InvoiceStatus.Cleared;
              invoice.CommandCode = InvoiceCommand.CustomerPrint;
            } else invoice.CommandCode = InvoiceCommand.ReprintForCustomer;
            break;
          case "ChangeCustomerPrintTemplate":
            if (
              invoice.StatusCode === InvoiceStatus.New ||
              invoice.StatusCode === InvoiceStatus.Pending ||
              invoice.StatusCode === InvoiceStatus.Ordering
            ) {
              invoice.StatusCode = InvoiceStatus.Cleared;
              invoice.CommandCode = InvoiceCommand.CustomerPrint;
            } else invoice.CommandCode = InvoiceCommand.ReprintForCustomer;
            break;
          case "PreparationPrint":
            if (invoice.StatusCode === InvoiceStatus.New || invoice.StatusCode === InvoiceStatus.Pending) {
              invoice.StatusCode = InvoiceStatus.Ordering;
              invoice.CommandCode = InvoiceCommand.PreparationPrint;
            } else invoice.CommandCode = InvoiceCommand.ReprintForPreparation;
            break;
          default:
        }
        break;
      default:
    }
    return invoice;
  }
  //دریافت اطلاعات فاکتور با دابل کلیک برروی فاکتور
  onDoubleClick(invoice: Invoice) {
    this.order.splashFormService.openDialog("", " ");
    if (!this.accountService.userHasPermission(`RestaurantSale:Invoice_${this.order.saleMethodBranch.SaleMethodId}`, Permission.editPermission)) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Order.Invoices.ItNotAccess"),
        this.translate("ClientApp.FrontOffice.Order.Invoices.ErrorDeletingInformation")
      );
      this.order.splashFormService.closeLoading();
      return;
    }
    if (this.order.saleMethodBranch?.HasDelino && invoice.WebId) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Order.Invoices.DelinoFactorCanNotBeEdited"),
        this.translate("ClientApp.FrontOffice.Order.Invoices.ItNotAccess")
      );
      this.order.splashFormService.closeLoading();
      return;
    }
    this.httpCommonService
      .getItem("Invoice/GetInvoiceById", invoice.Id)
      .pipe(take(1))
      .subscribe(
        (data: Invoice) => {
          if (data) {
            if (this.accountService.authService?.currentInformation()?.OrderServices && this.order.saleMethodBranch.HasDeposit) {
              this.order.depositFormGroup.setValue(new DepositModel());
              this.order.depositPersonnelList = [];
              this.order.depositServiceAmountSummary = "";
              this.order.depositServiceAmount = 0;
              this.order.isShowDeposit = false;
              this.getDepositValue(data.Id);
            }

            if (data.StatusCode === InvoiceStatus.Assigned) {
              if (!this.order.HasAccess("InvoicesEditWithDriverAssignment")) {
                this.order.splashFormService.closeLoading();
                this.sts.showToast(
                  "control",
                  this.translate("ClientApp.FrontOffice.Order.Invoices.NoAccess"),
                  this.translate("ClientApp.FrontOffice.Order.Invoices.AccessToEditInvoicesAssignedToPackage"),
                  5000
                );
                return;
              }
            }
            if (data.SettlementId) {
              this.sts.showDialog(
                `${this.translate("ClientApp.FrontOffice.Order.Invoices.InvoiceIsClosedAndCannotBeEdited")}`,
                this.translate("ClientApp.FrontOffice.Order.Invoices.ErrorMessage")
              );
              this.order.splashFormService.closeLoading();
              return;
            }
            if (typeof data.PaymentLinkState === "number") {
              const status = this.order.getStatusOfLinkPayment(data.PaymentLinkState);
              switch (status) {
                case PaymentLinkState.Paid:
                  if (this.order.currentSaleMethodNature === SaleMethodNature.Delivery && !this.order.saleMethodBranch.HasDeposit) {
                    this.sts.showDialog(
                      `${this.translate("ClientApp.FrontOffice.Order.Invoices.InvoicePaidThroughLinkAndPossibleToEditInvoice")}`,
                      this.translate("ClientApp.FrontOffice.Order.Invoices.ErrorMessage")
                    );
                    this.order.splashFormService.closeLoading();
                    return;
                  } else if (this.order.currentSaleMethodNature === SaleMethodNature.Restaurant && data.StatusCode == InvoiceStatus.Cleared) {
                    this.sts.showDialog(
                      `${this.translate("ClientApp.FrontOffice.Order.Invoices.InvoicePaidThroughLink")}`,
                      this.translate("ClientApp.FrontOffice.Order.Invoices.Warning")
                    );
                  }
                  break;

                default:
                  if (this.order.saleMethodBranch.IsPaymentLink && status > PaymentLinkState.Nothing) {
                    this.sts.showDialog(
                      `${this.translate("ClientApp.FrontOffice.Order.Invoices.LinkDesiredInvoiceCustomer")}`,
                      this.translate("ClientApp.FrontOffice.Order.Invoices.Warning"),
                      DialogType.confirm,
                      () => {
                        //بعد از تایید کاربر جهت تغییر فاکتور می بایست در سیستم لاگ ثبت گردد که کاربر بعد از ارسال لینک اقدام به تغییر فاکتور نموده است
                      },
                      () => {
                        //cancel call back
                        this.order.newInvoice();
                        this.order.setActivePage(ActivePageEnum.Invoices);
                      }
                    );
                  }
                  break;
              }
            }
            this.order.invoice = data;
            if (this.order.saleMethodBranch.ShowDescInvCustomer || this.order.saleMethodBranch.ShowDescInvKitchen) {
              const desResult = data.Description.split("///");
              this.order.invoice.DescKitchen = desResult[0];
              this.order.invoice.DescCustomer = desResult[1];
            }

            this.order.invoice.Items.forEach((item) => {
              if (!!item.RowDiscount) item.showPercent = true;
            });

            let output = new InvoiceEntry();
            let mapper = new MapObjectPipe();
            this.order.invoice.OriginalValue = JSON.parse(JSON.stringify(mapper.transform(data, output)));
            this.order.invoice.OriginalValue.SaleMethodBranch = this.order.saleMethodList.find((z) => z.Id === data.SaleMethodBranchId);
            this.order.invoice.Items = JSON.parse(
              JSON.stringify(
                data.Items.sort(function (a, b) {
                  return a.Index - b.Index;
                })
              )
            );
            this.order.invoice.Items = this.order.invoice.Items.filter((f) => f.State !== RowState.Delete);
            this.order.setValueformGroupControl();
            this.order.invoice.State = RowState.Modify;
            if (this.order.common.isMobileMode) this.order.setActivePage(ActivePageEnum.Invoice);
            else this.order.setActivePage(ActivePageEnum.Order);
            this.order.shouldActivateSalonPage = false;
            this.order.shouldActivateInvoicesPage = true;
            this.order.GetItemCategoryList();
            this.order.selectedInvoiceItem = Object.assign({}, this.order.invoice.Items[0]);
            this.order.selectedOrderItemIndex = Object.assign({}, this.order.invoice.Items[0].Index);
            this.order.shouldCalculateFreeShippingCost = false;
            this.order.setInvoiceHasFactorAndHasPaymentLink();
            this.order.freeShippingCostDiscount = null;
            this.order.setValue("BranchId", this.order.invoice.BranchId);
            this.order.ChangeBranch(this.order.invoice.BranchId, false);
            this.order.invoiceChanged = false;
            this.order.itemQuantityChanged = false;
            this.order.calculate();
            this.order.splashFormService.closeLoading();
            this.order.shouldCalculateFreeShippingCost = true;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getDepositValue(InvoiceId: number) {
    this.httpCommonService
      .getItem("Deposit/GetByInvoiceId", InvoiceId)
      .pipe(take(1))
      .subscribe((data: DepositModel) => {
        if (data) {
          const depositModel = new DepositModel();
          const mappedData: DepositModel = Object.prototype.CustomMap(data, depositModel);
          if (mappedData.ServingFoodDate) {
            mappedData.ServingFoodTime = moment(mappedData.ServingFoodDate).format("HH:mm").toString();
          }
          this.order.originalDeposit = mappedData;
          this.order.depositFormGroup.setValue(mappedData);
          this.order.depositPersonnelList = data.DepositPersonnelList;
          this.order.calcDepositServiceAmount(this.order.depositPersonnelList);
          this.order.isShowDeposit = true;
          this.order.detectChanges();
        }
      });
  }

  showDepositDateFilter(): void {
    if (this.depositFilterIsSelected) {
      this.onFilter = this.onFilter.filter((x) => x.Filed !== "StartDate");
      this.onFilter = this.onFilter.filter((x) => x.Filed !== "EndDate");
      this.onFilter = this.onFilter.filter((x) => x.Filed !== "HasInvoiceService");
      this.onFilter = Object.assign([], this.onFilter);
      this.depositFilterIsSelected = false;
      this.order.depositListGridFilter = null;
      this.cd.markForCheck();
      return;
    }
    const confirmValue: Subject<ConfirmDateValue> = new Subject();
    confirmValue
      .pipe(
        take(1),
        filter((x) => !!x)
      )
      .subscribe((value: ConfirmDateValue) => {
        const startDateFilter: GridFilter = {
          Filed: "StartDate",
          Value: value.StartDate,
          Skip: 0,
          Take: 0,
          Operator: "eq",
          Type: "F",
        };
        const endDateDateFilter: GridFilter = {
          Filed: "EndDate",
          Value: value.EndDate,
          Skip: 0,
          Take: 0,
          Operator: "eq",
          Type: "F",
        };
        const HasInvoiceServiceFilter: GridFilter = {
          Filed: "HasInvoiceService",
          Value: value.HasInvoiceService,
          Skip: 0,
          Take: 0,
          Operator: "eq",
          Type: "F",
        };
        this.onFilter = Object.assign([], this.onFilter);
        const startAndEndDateFilters = [startDateFilter, endDateDateFilter, HasInvoiceServiceFilter];
        this.onFilter.push(...startAndEndDateFilters);
        this.order.depositListGridFilter = startAndEndDateFilters;
        this.depositFilterIsSelected = true;
        this.cd.markForCheck();
      });
    this.dialogService.open(
      DateDialogComponent,
      { confirmValue, label: this.translate("ClientApp.FrontOffice.Order.Invoices.DayOrderService"), setDefaultDate: true, hasDeposit: true },
      {}
    );
  }

  retryLink() {
    if (!this.invoice || !this.invoice.Id) return;
    if (!this.invoice.PhoneNumber?.startsWith("09")) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Invoices.InvoiceMobileNumber")}`,
        this.translate("ClientApp.FrontOffice.Order.Invoices.ErrorMessage")
      );
      return;
    }
    if (this.invoice.Debit === this.invoice.PayableTotal) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Invoices.EntireAmountInvoiceDebited")}`,
        this.translate("ClientApp.FrontOffice.Order.Invoices.ErrorMessage")
      );
      return;
    }
    if (this.invoice.AutomaticDebtor) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Invoices.SendLinkCustomerAutomaticallyInDebt")}`,
        this.translate("ClientApp.FrontOffice.Order.Invoices.ErrorMessage")
      );
      return;
    }
    this.order.splashFormService.openDialog("", " ");
    this.httpCommonService
      .get(`Invoice/RetryLink/${this.invoice.Id}`)
      .pipe(take(1))
      .subscribe(
        () => {
          this.order.splashFormService.closeLoading();
        },
        () => {
          this.order.splashFormService.closeLoading();
        }
      );
  }

  setactions() {
    this.actions = [
      {
        name: "CustomerPrint",
        disabled: false,
        displayName: this.translate("ClientApp.FrontOffice.Order.Invoices.CustomerPrint"),
        iconName: "icon-print-o",
        apiName: "Invoice/GetInvoices",
        areaName: "RestaurantSale",
        permission: Permission.samePermission,
      },
      {
        name: "PreparationPrint",
        disabled: false,
        displayName: this.translate("ClientApp.FrontOffice.Order.Invoices.KitchenPrint"),
        iconName: "icon-print-f",
        apiName: "Invoice/GetInvoices",
        areaName: "RestaurantSale",
        permission: Permission.samePermission,
      },
      {
        name: "ChangeCustomerPrintTemplate",
        disabled: false,
        displayName: this.translate("ClientApp.FrontOffice.Order.Invoices.ChangingTemplateTimeOfPrinting"),
        iconName: "icon icon-printer-bold",
        apiName: "Invoice/GetInvoices",
        areaName: "RestaurantSale",
        permission: Permission.samePermission,
      },
    ];

    if (
      (this.order.saleMethodBranch.SaleMethodNatureCode == SaleMethodNature.Restaurant ||
        this.order.saleMethodBranch.SaleMethodNatureCode == SaleMethodNature.FastFood) &&
      !this.actions.some((c) => c.name === "SendInvoiceSms")
    ) {
      this.actions.push({
        name: "SendInvoiceSms",
        disabled: false,
        displayName: this.translate("ClientApp.FrontOffice.Order.Invoices.SendInvoiceSms"),
        iconName: "icon-sms",
        apiName: "Invoice/GetInvoices",
        areaName: "RestaurantSale",
        permission: Permission.samePermission,
      });
    }

    if (this.order.saleMethodBranch.HasDeposit && !this.actions.some((c) => c.name === "PrintReceipt")) {
      this.actions.push({
        name: "PrintReceipt",
        disabled: false,
        displayName: this.translate("ClientApp.FrontOffice.Order.Invoices.PrintReceipt"),
        iconName: "icon icon-printer-regular",
        apiName: "Invoice/GetInvoices",
        areaName: "RestaurantSale",
        permission: Permission.samePermission,
      });
    }
  }

  changePrintTemplate() {
    this.totalPriceService.changePrintTemplate(this.invoice);
  }
  onRowSelected(invoice: Invoice) {
    this.invoice = invoice;
    this.getInvoiceById(invoice);
  }
  private getInvoiceById(invoice: Invoice) {
    this.httpCommonService
      .getItem("Invoice/GetInvoiceById", invoice.Id)
      .pipe(take(1))
      .subscribe(
        (data: Invoice) => {
          if (data) {
            this.invoice = data;
            this.InvoiceItems = data.Items;
            this.cd.markForCheck();
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  public setFilter($event): void {
    const key = $event.value;
    if (this.selectedFilter === key) {
      this.selectedFilter = null;
      this.onFilter = Object.assign([], this.filterInfo);
      return;
    }
    this.selectedFilter = key;
    this.onFilter = this.onFilter.filter((x) => x.Filed !== "StatusCode");
    this.onFilter = Object.assign([], this.onFilter);
    this.onFilter.push({
      Filed: "StatusCode",
      Value: key,
      Skip: 0,
      Take: 0,
      Operator: "eq",
      Type: "F",
    });

    if (this.onFilter.length <= 0) this.onFilter = Object.assign([], this.filterInfo);
  }
  invoiceFilterClear() {
    this.onFilter = this.onFilter.filter((x) => x.Filed !== "StatusCode");
    if (this.onFilter.length <= 0) this.onFilter = Object.assign([], this.filterInfo);
  }
  GetInvoices() {
    this.isFinishedData = true;
    this.httpCommonService
      .create("Invoice/ReadGetAllInvoices", this.filterInfo)
      .pipe(take(1))
      .subscribe(
        (data: PagingDataResult<Invoice>) => {
          this.invoices = data;
          this.isFinishedData = false;
          this.cd.markForCheck();
          setTimeout(() => {
            this.cd.markForCheck();
          }, 1000);
        },
        (err) => {
          this.isFinishedData = false;
          console.log(err);
        }
      );
  }
  onMealTimeChanged(mealTime: EnumModel[]) {
    this.onFilter = this.onFilter.filter((x) => x.Filed !== "MealTime");
    this.onFilter = Object.assign([], this.onFilter);
    mealTime.forEach((mealTime) => {
      const mealTimeFilter: GridFilter = {
        Filed: "MealTime",
        Value: mealTime.Id,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      };
      this.onFilter.push(...[mealTimeFilter]);
    });
  }
  private filterBranchWithOrOperator(branches: Branch[]): void {
    if (branches.length > 1) {
      this.filterInfo.forEach((x) => (x.Logic = "and"));
    }
    this.onFilter = Object.assign([], this.filterInfo);
    branches.forEach((branch) => {
      const branchFilter: GridFilter = {
        Filed: "BranchId",
        Value: branch.Id,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      };
      const SaleMethodBranch = this.order.saleMethodList.find(
        (f) => f.BranchId == branch.Id && f.SaleMethodId === this.order.saleMethodBranch.SaleMethodId
      );
      const SaleMethodFilter: GridFilter = {
        Filed: "SaleMethodId",
        Value: SaleMethodBranch.SaleMethodId,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      };
      const SaleMethodBranchFilter: GridFilter = {
        Filed: "SaleMethodBranchId",
        Value: SaleMethodBranch.Id,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      };
      if (branches.length > 1) {
        branchFilter.Logic = "or";
        SaleMethodFilter.Logic = "or";
        SaleMethodBranchFilter.Logic = "or";
      }
      this.onFilter.push(...[branchFilter, SaleMethodBranchFilter, SaleMethodFilter]);
    });
  }

  private setDefaultBranch(): void {
    if (this.order.currentSaleMethodNature === this.order.SaleMethodNature.Delivery && this.order.isMultiBranch) {
      const branchId = this.order.formGroup.get("BranchId").value;
      if (branchId) {
        const branch = this.order.Branches.find((x) => x.Id === branchId);
        this.formGroup.get("branchFilter").setValue([branchId]);
        this.onBranchFilterChanged([branch]);
      } else {
        this.onFilter = [
          {
            Filed: "BranchId",
            Value: 0,
            Skip: 0,
            Take: 0,
            Operator: "eq",
            Type: "F",
          },
        ];
      }
    }
  }

  pritFactors() {
    let invoices: Invoice[] = this.invoiceGrid?.grid?.data["data"];
    let InvoiceIds = [];
    invoices.map((x) => InvoiceIds.push(x.Id));

    if (invoices.length) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Invoices.WantToPrint")} ${invoices.length} ${this.translate(
          "ClientApp.FrontOffice.Order.Invoices.AreInvoice"
        )}`,
        this.translate("ClientApp.FrontOffice.Order.Invoices.Warning"),
        DialogType.confirm,
        () => {
          this.splashFormService.openDialog();
          this.httpCommonService
            .create("invoice/InvoicesPrint", InvoiceIds)
            .pipe(take(1))
            .subscribe(
              (data: Invoice[]) => {
                this.splashFormService.closeLoading();
                invoices = data;
                if (this.order.logInBranch) {
                  invoices.forEach(async (invoice) => {
                    await this.invoiceAction.invoicePrintService.PrintLocalInvoice(invoice).then();
                  });
                }
              },
              (err) => {
                this.splashFormService.closeLoading();
                console.log(err);
              }
            );
        }
      );
    }
  }

  private sendInvoiceSms(data: Invoice): void {
    if (data.PhoneNumber) {
      if (!data.PhoneNumber?.startsWith("09")) {
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Order.Invoices.InvoiceMobileNumber")}`,
          this.translate("ClientApp.FrontOffice.Order.Invoices.ErrorMessage")
        );
      } else {
        this.httpCommonService
          .getItem("Invoice/SendInvoiceSms", data.Id)
          .pipe(take(1))
          .subscribe(() => {
            console.log("SMS was sent to the customer");
          });
      }
    } else {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Order.Invoices.TheCustomerDoNotHaveMobile"),
        this.translate("ClientApp.FrontOffice.Order.Invoices.ItNotSendSMS")
      );
    }
  }

  async deleteInvoiceExtra(event: boolean) {
    if (!event) return;
    if (this.invoice.DiscountType !== DiscountTypeEnum.Organization) return;
    if (this.invoice.Customer.Id !== this.order.invoice.Customer.Id) return;

    await this.updateCustomer();
  }
  async updateCustomer() {
    this.httpCommonService
      .getItem("Customer/GetCustomerDetails", this.invoice.CustomerId)
      .pipe(take(1))
      .subscribe(
        (data: Customer) => {
          if (data) {
            this.invoice.Customer = data;
            this.order.invoice.Customer = data;
            this.cd.markForCheck();
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
